import React, { useContext, useState, useEffect } from "react";
import { UserContext } from "../../App";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBookOpen,
  faFileAlt,
  faGraduationCap,
  faComments,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import "./HomePage.css";

const HomePage = ({ setPageTitle }) => {
  const { firstName, role } = useContext(UserContext);
  const [displayText, setDisplayText] = useState("");
  const [showSecondMessage, setShowSecondMessage] = useState(false);
  const [showButtons, setShowButtons] = useState(false);
  const [startAnimation, setStartAnimation] = useState(false);
  const navigate = useNavigate();

  const formatName = (name) => {
    if (!name) return "";
    return (
      name.toLowerCase().charAt(0).toUpperCase() + name.toLowerCase().slice(1)
    );
  };

  const welcomeMessage = `Hello, ${formatName(firstName)}.`;

  useEffect(() => {
    setPageTitle("Home");
  }, [setPageTitle]);

  useEffect(() => {
    if (firstName && firstName !== "DefaultFirstName") {
      setStartAnimation(true);
    }
  }, [firstName]);

  useEffect(() => {
    if (!startAnimation) return;

    let currentIndex = 0;
    const intervalId = setInterval(() => {
      if (currentIndex <= welcomeMessage.length) {
        setDisplayText(welcomeMessage.slice(0, currentIndex));
        currentIndex++;
      } else {
        clearInterval(intervalId);
        setTimeout(() => {
          setShowSecondMessage(true);
          setTimeout(() => {
            setShowButtons(true);
          }, 500);
        }, 500);
      }
    }, 100);

    return () => clearInterval(intervalId);
  }, [welcomeMessage, startAnimation]);

  const handleButtonClick = (path) => {
    // Add slide-out class to all buttons
    const buttons = document.querySelectorAll(".action-button");
    buttons.forEach((button) => button.classList.add("slide-out"));

    // Wait for animation to complete before navigating
    setTimeout(() => {
      navigate(path);
    }, 1600); // Total animation time (1s animation + 0.6s max delay)
  };

  const renderButtons = () => {
    if (role === "student" || role === "studentplus") {
      return (
        <>
          <button
            className="action-button"
            onClick={() => handleButtonClick("/my-courses")}
          >
            <FontAwesomeIcon icon={faBookOpen} className="button-icon" />
            Courses
          </button>
          <button
            className="action-button"
            onClick={() => handleButtonClick("/feedback")}
          >
            <FontAwesomeIcon icon={faComments} className="button-icon" />
            Feedback
          </button>
          <button
            className="action-button"
            onClick={() => handleButtonClick("/student-gradebook")}
          >
            <FontAwesomeIcon icon={faGraduationCap} className="button-icon" />
            Gradebook
          </button>
        </>
      );
    }
    return (
      <>
        <button
          className="action-button"
          onClick={() => handleButtonClick("/courses")}
        >
          <FontAwesomeIcon icon={faBookOpen} className="button-icon" />
          Courses
        </button>
        <button
          className="action-button"
          onClick={() => handleButtonClick("/class-lists")}
        >
          <FontAwesomeIcon icon={faFileAlt} className="button-icon" />
          Classlists
        </button>
        <button
          className="action-button"
          onClick={() => handleButtonClick("/gradebook")}
        >
          <FontAwesomeIcon icon={faGraduationCap} className="button-icon" />
          Grading
        </button>
        {(role === "admin" ||
          role === "technician" ||
          role === "technicianplus") && (
          <button
            className="action-button"
            onClick={() => handleButtonClick("/user-management")}
          >
            <FontAwesomeIcon icon={faUser} className="button-icon" />
            Users
          </button>
        )}
      </>
    );
  };

  return (
    <div className="home-page">
      <div className="welcome-container">
        <h1 className="welcome-message">{displayText}</h1>
        {showSecondMessage && (
          <p className="follow-up-message fade-in">
            What will you work on today?
          </p>
        )}
        {showButtons && (
          <div className="action-buttons fade-in">{renderButtons()}</div>
        )}
      </div>
    </div>
  );
};

export default HomePage;
